import { render } from "./InventoryItem.vue?vue&type=template&id=0a3ab7ae"
import script from "./InventoryItem.vue?vue&type=script&lang=js"
export * from "./InventoryItem.vue?vue&type=script&lang=js"

import "./InventoryItem.vue?vue&type=style&index=0&id=0a3ab7ae&lang=css"
script.render = render

export default script